module.exports = __webpack_public_path__ + "static/media/bywise-logo.3a1b7f6c.png";